import {Action, Dispatch} from "redux";
import {FacetedFilters, IResearchPagination} from "../../model/ResearchPageState.model";

export enum ResearchPageActionTypes {
    UPDATE_RESEARCH_FACETED_FILTERS = "UPDATE_RESEARCH_FACETED_FILTERS",
    UPDATE_RESEARCH_SEARCH_TEXT = "UPDATE_RESEARCH_SEARCH_TEXT",
    UPDATE_RESEARCH_PAGINATION = "UPDATE_RESEARCH_PAGINATION",
    SET_RESEARCH_SCROLL_TO = "SET_RESEARCH_SCROLL_TO",
    CLEAR_ALL_RESEARCH_FILTERS = "CLEAR_ALL_RESEARCH_FILTERS",
}

export const updateFacetedFiltersAction = (facetedFilters: FacetedFilters) => {
    return (dispatch: Dispatch<Action<ResearchPageActionTypes>>) => {
        dispatch({type: ResearchPageActionTypes.UPDATE_RESEARCH_FACETED_FILTERS, payload: {facetedFilters}});
    };
};

export const updateSearchTextAction = (searchText: string) => {
    return (dispatch: Dispatch<Action<ResearchPageActionTypes>>) => {
        dispatch({type: ResearchPageActionTypes.UPDATE_RESEARCH_SEARCH_TEXT, payload: {searchText}});
    };
};

export const updatePaginationAction = (pagination: IResearchPagination) => {
    return (dispatch: Dispatch<Action<ResearchPageActionTypes>>) => {
        dispatch({type: ResearchPageActionTypes.UPDATE_RESEARCH_PAGINATION, payload: {pagination}});
    };
};

export const setScrollToBackstopAction = (backstopId: number) => {
    return (dispatch: Dispatch<Action<ResearchPageActionTypes>>) => {
        dispatch({type: ResearchPageActionTypes.SET_RESEARCH_SCROLL_TO, payload: {scrollToBackstopId: backstopId}});
    };
};

export const clearAllFiltersAction = () => {
    return (dispatch: Dispatch<Action<ResearchPageActionTypes>>) => {
        dispatch({type: ResearchPageActionTypes.CLEAR_ALL_RESEARCH_FILTERS});
    };
};

export default {
    updateFacetedFiltersAction,
    updateSearchTextAction,
    updatePaginationAction,
    setScrollToBackstopAction,
    clearAllFiltersAction,
};
